import { mockableWithRef } from '../../../../config/mockable';
import {
    POSITION,
    SearchMap,
} from './SearchMap';

const searchMapResolver = () => SearchMap;

const MockableSearchMap = mockableWithRef(searchMapResolver);

export {
    POSITION,
    MockableSearchMap as SearchMap,
    searchMapResolver,
};
